<template>
  <div class="vx-row no-gutter items-center justify-center">
    <div class="vx-col sm:w-5/6 md:w-2/3 lg:w-1/2 m-0">
      <vx-card class="login-card py-3 px-3">
        <div slot="no-body" class="">
          <div class="vx-col sm:w-full">
            <div class="px-6 pt-8 login-tabs-container">

              <div class="vx-card__title mb-4">
                <h4 class="mb-4">Activación de cuenta.</h4>
              </div>

              <template v-if="isMounted && completed">
                <vs-alert class="h-full mb-5" color="success">
                  <span class="bold">¡Tu cuenta ha sido activada exitosamente!</span>
                </vs-alert>
                <p>Para continuar, visita la página de inicio e ingresa tus credenciales. ¡Gracias por ser parte de la Red!</p>
              </template>

              <template v-if="isMounted && !completed">
                <vs-alert v-if="errorMssg" class="h-full mb-5" color="danger">
                  <span>{{ errorMssg }}</span>
                </vs-alert>
                <p>Si tienes dudas por favor contáctanos a través del chat de la plataforma.</p>
              </template>

              <div class="mt-base mb-6">
                <div class="text-dark">
                  Ir a la <span><router-link class="bold ml-1 inline-link-primary text-dark" to="" @click.native="backToLogin">página de inicio.</router-link></span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
const errorMssgDef = "Ha ocurrido un error al agregar al representante, intente más tarde."
export default {
  name: "PreAuth",
  props: ['token'],
  data(){
    return {
      completed: false,
      errorMssg: null,
      isMounted: false,
    }
  },
  async mounted(){
    this.isMounted = false
    this.showLoading(true)
    await this.checkForToken();
    this.isMounted = true
    this.showLoading(false)
  },
  methods: {
    async checkForToken(){
      try {
        const payload = {token: this.$props.token};
        const res = await this.publicApiPost('/api/v2/preregister/preauth', payload);
        this.completed = true;
      }
      catch(error) {
        this.completed = false;
        if(error.response && error.response.data && error.response.data.message){
          this.errorMssg = error.response.data.message;
        }
        else {
          this.errorMssg = errorMssgDef;
        }
      }
    },
  }
}
</script>

<style scoped>

</style>